import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { ContentBlock, ContentState } from "draft-js";
import React, { FC } from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { TrashOutlineIcon } from "shared/theme/icons/TrashOutlineIcon";
import { StyledContainer } from "./styled";

type Props = {
  block: ContentBlock;
  blockProps: {
    onDelete: (blockKey: string) => void;
  };
  contentState: ContentState;
};

const TableOfContents: FC<Props> = (props) => {
  const { block, blockProps } = props;
  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    const blockKey = block.getKey();
    blockProps.onDelete(blockKey);
  };

  return (
    <>
      <StyledContainer>
        <Typography variant="bodyLMedium" color={COLOR_PRIMARY_MAIN}>
          Table of Contents
        </Typography>
        <IconButton sx={{ padding: 0 }} onClick={handleDelete}>
          <TrashOutlineIcon size={24} />
        </IconButton>
      </StyledContainer>
    </>
  );
};

export default TableOfContents;
